module.exports = __webpack_public_path__ + "media/images/top_seats-b0dd990e633227acfb63bcc7938f8ca0.svg";